const selector = '.Toaster';
const messageSelector = '.Toaster__message';
const showClassName = 'Toaster--show';
let $toasterEl;
let $messageEl;
let hideTimout;
const defaultOptions = {
  duration: 3000,
};

function show(options) {
  if (!$toasterEl) {
    $toasterEl = $(selector);
  }
  $toasterEl.addClass(showClassName);
  hideTimout = setTimeout(hide, options.duration);
}

function hide() {
  if (!$toasterEl) {
    $toasterEl = $(selector);
  }
  $toasterEl.removeClass(showClassName);

  $messageEl.html('');
}

export default function(message, options = {}) {
  const toasterOptions = {
    ...defaultOptions,
    options,
  };
  clearTimeout(hideTimout);
  clearTimeout(clearTimeout);
  if (!$messageEl) {
    $messageEl = $(messageSelector);
  }
  $messageEl.html(message);
  show(toasterOptions);
}



// WEBPACK FOOTER //
// ./scripts/components/toaster.js